// src/components/Onboarding/canvas/canvasConstants.js
// Canvas configuration constants and shimmer effect settings

// ========================================
// PERFORMANCE CONSTANTS
// ========================================
export const MAX_DPR = 2; // Cap device pixel ratio for mobile performance
export const MAX_BACKING_PIXELS = 2_000_000; // 2MP max backing store
export const HOTSPOT_UPDATE_INTERVAL = 50; // 20Hz hotspot updates (ms)
export const MASK_SCALE = 0.5; // Masks at 50% resolution for memory savings

// ========================================
// SHIMMER EFFECT CONFIGURATION
// ========================================
// All shimmer visual parameters in one place for easy adjustment.
// These are the ACTUAL variables that control shimmer appearance.
//
// To customize: import SHIMMER_CONFIG and spread with overrides:
//   { ...SHIMMER_CONFIG, periodMs: 2000, baseColor: 'rgba(0,0,0,0.2)' }
//
export const SHIMMER_CONFIG = {
  // ─────────────────────────────────────────
  // TIMING
  // ─────────────────────────────────────────
  periodMs: 1800,              // Full animation cycle duration (ms)
                               // Lower = faster sweep, Higher = slower sweep
                               // Recommended: 1200-2500ms

  // ─────────────────────────────────────────
  // COLORS
  // ─────────────────────────────────────────
  baseColor: 'rgba(180, 200, 220, 0)',   // Background tint color
                                             // This fills the shimmer area constantly
                                             // Use low alpha (0.1-0.4) for subtlety

  shimmerColor: 'rgba(255, 255, 255, 0.6)', // Moving highlight color
                                             // The bright band that sweeps across
                                             // White works best, adjust alpha for intensity

  // ─────────────────────────────────────────
  // GEOMETRY
  // ─────────────────────────────────────────
  angleDeg: 0,               // Sweep angle in degrees
                               // 0 = horizontal, 90 = vertical
                               // Negative = top-right to bottom-left
                               // Recommended: -30 to -10 for natural diagonal

  bandWidth: 0.35,             // Width of shimmer band (0-1 as proportion of diagonal)
                               // 0.2 = thin sharp line
                               // 0.5 = wide soft glow
                               // Recommended: 0.25-0.45

  // ─────────────────────────────────────────
  // GRADIENT SHAPE (controls band softness)
  // ─────────────────────────────────────────
  // These control how the shimmer band fades in/out
  // Values are positions within the band (0-1)
  gradientStops: {
    fadeInEnd: 0.3,            // Where fade-in completes (0 = instant, 0.5 = gradual)
    solidStart: 0.3,           // Where solid color begins
    solidEnd: 0.7,             // Where solid color ends
    fadeOutStart: 0.7,         // Where fade-out begins (should match solidEnd)
  },

  // ─────────────────────────────────────────
  // MASK EDGE SOFTENING
  // ─────────────────────────────────────────
  // Feathers/blurs the mask edges to hide segmentation imperfections.
  // Applied ONCE when mask changes (not per-frame) for performance.
  // Unit: MASK-CANVAS PIXELS (at MASK_SCALE resolution, typically 50%).
  // Since masks are downscaled, a value of 10px here ≈ 20px at full resolution.
  maskFeatherPx: 4,            // Edge blur radius in mask-canvas pixels
                               // 0 = sharp edges (no feathering)
                               // 2-5 = subtle softening
                               // 6-12 = noticeable blur  
                               // 15+ = very soft/dreamy edges
                               // Recommended: 4-10 for natural look
};
